import { makeRunFromStartAction } from '../../common-actions/run-from-start.action';
import { ToolCallModel } from '../tool-call.model';
import { ToolCallColumnSnapshotAction } from './tool-call-column-snapshot.action';

export class ToolCallRunFromStartAction extends makeRunFromStartAction(
  'Run From Start',
  ToolCallModel,
  ToolCallColumnSnapshotAction
) {}
